import React from 'react';

export const FileTypeBadge: React.FC<{ type: string }> = ({ type }) => {
  const getCategoryColor = (t: string) => {
    if (t.includes('NHS') || t.includes('HEALTH') || t.includes('GP')) return 'bg-primary/10 text-primary border-primary/20';
    if (t.includes('OFSTED') || t.includes('EDU')) return 'bg-secondary/10 text-secondary border-secondary/20';
    if (t.includes('POLICE')) return 'bg-destructive/10 text-destructive border-destructive/20';
    if (t.includes('GEO') || t.includes('ORDNANCE') || t.includes('POSTCODE')) return 'bg-primary/10 text-primary border-primary/20';
    return 'bg-muted text-muted-foreground border-border';
  };

  return (
    <span className={`px-2 py-0.5 rounded border text-[10px] font-bold tracking-wider uppercase ${getCategoryColor(type)}`}>
      {type.replace(/_/g, ' ')}
    </span>
  );
};
